export const REGISTER_PORT_CONNECTION_ACK = 'REGISTER_PORT_CONNECTION_ACK';
export const REGISTER_PORT_CONNECTION_ACK_FAILED = 'REGISTER_PORT_CONNECTION_ACK_FAILED';

// TODO: New workers will no longer send this message it can eventually be cleaned up.
export const HEARTBEAT_REQUEST = 'HEARTBEAT_REQUEST';
export const PORT_CONNECTION_COMPLETE = 'PORT_CONNECTION_COMPLETE';
export const isHeartBeatRequestMessage = message => message && message.type === HEARTBEAT_REQUEST;
export function isRegisterPortConnectionAckMessage(message) {
  return message && message.type === REGISTER_PORT_CONNECTION_ACK;
}
export function isRegisterPortConnectionAckFailedMessage(message) {
  return message && message.type === REGISTER_PORT_CONNECTION_ACK_FAILED;
}
export function isPortConnectionComplete(message) {
  return message && message.type === PORT_CONNECTION_COMPLETE;
}